import React, { useState } from "react";
import axios from "axios";
import AllCategories from "../../globalcomponents/navbar/categorieslist/AllCategories";
import MobileCategories from "../../globalcomponents/navbar/categorieslist/MobileCategories";
import CountryLanguage from "../../globalcomponents/navbar/location/CountryLanguage";
import Currency from "../../globalcomponents/navbar/location/Currency";
import DeliveryLocationPicker from "../../globalcomponents/location/DeliveryLocationPicker";
import Navbar from "../../globalcomponents/navbar/Navbar";
import SideCart from "../../globalcomponents/SideCart/SideCart";
import HomeHeroShowcase from "./HomeHeroShowcase/HomeHeroShowcase";
import AdPlacement from "../../globalcomponents/ads/AdPlacement";
import CarouselBanner from "./banner/Carousel-banner";
import { HomePageProvider } from "./HomePageContext";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { RootState } from "../../../store";
import { useEffect } from "react";
import {
  fetchProductsWithCoupons,
  fetchProductsWithDeals,
} from "../../../Redux/ecommersProduct/slice";
import { getKeepShopping } from "../../../Redux/ActivityApi/slice";
import { fetchSuperCategories } from "../../../Redux/filters/slice";
import CategoriesBar from "../../globalcomponents/navbar/categorieslist/CategoriesBar";
import ProDetailModal from "./components/ProDetailModal";
import { useHomePageContext } from "./HomePageContext";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import {
  getAllAddresses,
  setDefaultAddress,
} from "../../../Redux/customer-address/slice";
import { setDeliveryLocation } from "../../../Redux/delivery-location/slice";
import { Address } from "../../../Redux/customer-address/types";

import HomeNavbar from "../../globalcomponents/HomeNavbar/HomeNavbar";
import HomeSecondaryNavbar from "../../globalcomponents/HomeSecondaryNavbar/HomeSecondaryNavbar";
import WomenFashionSection from "./FashionProductSection/WomenFashionSection/WomenFashionSection";
import FashionPromoBanner from "./FashionProductSection/FashionPromoBanner/FashionPromoBanner";
import MenFashionSection from "./FashionProductSection/MenFashionSection/MenFashionSection";
import GroceryPromoBanner from "./GroceryProductsSection/GroceryPromoBanner/GroceryPromoBanner";
import GroceryProductsSection from "./GroceryProductsSection/GroceryProductsSection";
import HomeAppliancesPromoBanner from "./HomeAppliancesProducts/HomeAppliancesPromoBanner/HomeAppliancesPromoBanner";
import HomeAppliancesProducts from "./HomeAppliancesProducts/HomeAppliancesProducts";
import ElectronicsPromoBanner from "./ElectronicsProductsSection/ElectronicsPromoBanner/ElectronicsPromoBanner";
import ElectronicsProductsSection from "./ElectronicsProductsSection/ElectronicsProductsSection";
import CustomerTestimonials from "./Testimonials/CustomerTestimonials/CustomerTestimonials";
import SellerTestimonials from "./Testimonials/SellerTestimonials/SellerTestimonials";
import HomeSocialMedia from "./HomeSocialMedia/HomeSocialMedia";
import MobileHomePage from "../../globalcomponents/mobile/MobileHomePage/MobileHomePage";

const PRODUCT_BASE_URL = `${process.env.REACT_APP_API_BASE_URL || ""}${process.env.REACT_APP_ECOMMERCE_PERFIX || ""}`;

interface ActiveCategorySection {
  id: string;
  name: string;
  level: "superCategory";
  superCategory?: string | null;
  count: number;
}

const CATEGORY_GRADIENTS: Record<string, string> = {
  Groceries: "linear-gradient(135deg, #2d6a4f 0%, #52b788 100%)",
  Fresh: "linear-gradient(135deg, #1b7a3e 0%, #74c69d 100%)",
  Men: "linear-gradient(135deg, #1d3557 0%, #457b9d 100%)",
  Women: "linear-gradient(135deg, #8b2fc9 0%, #e0aaff 100%)",
  Kids: "linear-gradient(135deg, #e76f51 0%, #f4a261 100%)",
  Electronics: "linear-gradient(135deg, #023e8a 0%, #0096c7 100%)",
  Mobiles: "linear-gradient(135deg, #03045e 0%, #0077b6 100%)",
  Appliances: "linear-gradient(135deg, #3a0ca3 0%, #7209b7 100%)",
  "Home & Kitchen": "linear-gradient(135deg, #6d4c41 0%, #d7a373 100%)",
  Beauty: "linear-gradient(135deg, #c77dff 0%, #ff9a9e 100%)",
  "Personal Care": "linear-gradient(135deg, #f77f00 0%, #fcbf49 100%)",
  Footwear: "linear-gradient(135deg, #3d405b 0%, #81b29a 100%)",
  Jewellery: "linear-gradient(135deg, #b5851b 0%, #f9c74f 100%)",
  Sports: "linear-gradient(135deg, #d62828 0%, #f77f00 100%)",
  Fitness: "linear-gradient(135deg, #007f5f 0%, #55a630 100%)",
  Books: "linear-gradient(135deg, #370617 0%, #dc2f02 100%)",
  Accessories: "linear-gradient(135deg, #4a4e69 0%, #9a8c98 100%)",
  Furniture: "linear-gradient(135deg, #5c4033 0%, #a1683a 100%)",
  Toys: "linear-gradient(135deg, #ff6d00 0%, #ffbe0b 100%)",
};

const DEFAULT_GRADIENT = "linear-gradient(135deg, #2b2d42 0%, #8d99ae 100%)";

const BannerSection: React.FC<{ image?: string; categoryName?: string }> = ({
  image,
  categoryName,
}) => {
  if (!categoryName) return null;
  const gradient = CATEGORY_GRADIENTS[categoryName] || DEFAULT_GRADIENT;
  return (
    <div
      className="my-4 d-flex align-items-center px-4"
      style={{
        height: 90,
        borderRadius: 12,
        background: gradient,
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* decorative circle accents */}
      <div
        style={{
          position: "absolute",
          right: -30,
          top: -30,
          width: 160,
          height: 160,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.07)",
        }}
      />
      <div
        style={{
          position: "absolute",
          right: 60,
          bottom: -50,
          width: 120,
          height: 120,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.05)",
        }}
      />

      {image && (
        <img
          src={image}
          alt={categoryName}
          style={{
            height: 70,
            width: 70,
            objectFit: "contain",
            borderRadius: 8,
            marginRight: 20,
            flexShrink: 0,
            background: "rgba(255,255,255,0.15)",
            padding: 6,
          }}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      )}
      <div>
        <p
          className="mb-0 text-white fw-bold"
          style={{ fontSize: 20, letterSpacing: 0.5 }}
        >
          {categoryName}
        </p>
        <p
          className="mb-0"
          style={{ fontSize: 12, color: "rgba(255,255,255,0.78)" }}
        >
          Explore the collection &nbsp;›
        </p>
      </div>
    </div>
  );
};

const HomePageContent = () => {
  const dispatch = useAppDispatch();
  const [browsingHistoryOpen, setBrowsingHistoryOpen] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const { superCategories } = useAppSelector(
    (state: RootState) => state.filters,
  );
  const {
    productsWithCoupons,
    productsWithDeals,
    loading: productLoading,
  } = useAppSelector((state: RootState) => state.eCommerceProducts);
  const { keepShopping, keepShoppingLoaded } = useAppSelector(
    (state: RootState) => state.activity,
  );
  const { addresses, loading: addressLoading } = useAppSelector(
    (state: RootState) => state.customerAddress,
  );

  const [activeCategorySections, setActiveCategorySections] = useState<
    ActiveCategorySection[]
  >([]);

  const handleSelectDefault = (addr: Address) => {
    if (!addr._id) return;
    dispatch(setDefaultAddress(addr._id)).then(() => {
      dispatch(getAllAddresses());
    });
    dispatch(
      setDeliveryLocation({
        label: addr.addressType ?? "Home",
        area: addr.addressLine1,
        city: addr.city,
        state: addr.state,
        pincode: addr.pincode,
        displayName: `${addr.city}, ${addr.pincode}`,
        latitude: addr.latitude,
        longitude: addr.longitude,
      }),
    );
  };

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getAllAddresses());
    }
    if (superCategories.data.length === 0 && !superCategories.loading) {
      dispatch(
        fetchSuperCategories({
          categoryTypeName: "Ecommerce",
          showOnWebsite: true,
          showOnHomepage: true,
        }),
      );
    }
    if (
      productsWithCoupons.length === 0 &&
      !productLoading.productsWithCoupons
    ) {
      dispatch(fetchProductsWithCoupons({ page: 1, limit: 4 }));
    }
    if (productsWithDeals.length === 0 && !productLoading.productsWithDeals) {
      dispatch(
        fetchProductsWithDeals({
          page: 1,
          limit: 4,
          discountType: "PERCENT_OFF",
          minDiscountValue: 60,
        }),
      );
    }
    if (!keepShoppingLoaded || keepShopping.length < 10) {
      dispatch(getKeepShopping(10));
    }

    let cancelled = false;
    const fetchActiveCategories = async () => {
      try {
        const res = await axios.get(
          `${PRODUCT_BASE_URL}/e-commerce/catalog/products`,
          { params: { page: 1, limit: 48 } }
        );
        const products = res.data?.data?.products || [];

        const superCatMap = new Map<string, number>();

        products.forEach((p: any) => {
          const s = p.categoryHierarchy?.superCategory;
          if (s && s.toLowerCase() !== "products") {
            superCatMap.set(s, (superCatMap.get(s) || 0) + 1);
          }
        });

        const sections: ActiveCategorySection[] = [];
        const addedNames = new Set<string>();

        // 1. Add all superCategories that have products in catalog (sorted by count descending)
        const sortedSuperCats = Array.from(superCatMap.entries()).sort(
          (a, b) => b[1] - a[1]
        );
        for (const [name, count] of sortedSuperCats) {
          const lower = name.toLowerCase().trim();
          if (!addedNames.has(lower)) {
            addedNames.add(lower);
            sections.push({
              id: `super-${name}`,
              name,
              level: "superCategory",
              superCategory: name,
              count,
            });
          }
        }

        // 2. Also add configured superCategories from Redux / API
        if (superCategories?.data?.length > 0) {
          for (const sc of superCategories.data) {
            if (sc?.name) {
              const lower = sc.name.toLowerCase().trim();
              if (lower !== "products" && !addedNames.has(lower)) {
                addedNames.add(lower);
                sections.push({
                  id: `super-${sc._id || sc.name}`,
                  name: sc.name,
                  level: "superCategory",
                  superCategory: sc.name,
                  count: 0,
                });
              }
            }
          }
        }

        if (!cancelled) {
          setActiveCategorySections(sections);
        }
      } catch (err) {
        console.error("Failed to fetch active category sections:", err);
      }
    };

    fetchActiveCategories();
    return () => {
      cancelled = true;
    };
  }, [superCategories.data]);

  const { selectedProduct } = useHomePageContext();
  console.log("superCategories", superCategories);

  let fashionBannerRendered = false;
  let electronicsBannerRendered = false;
  let groceryBannerRendered = false;
  let appliancesBannerRendered = false;

  const getCategoryPromoBanner = (catName?: string): React.ReactNode => {
    if (!catName) return null;
    const name = catName.toLowerCase().trim();

    if (
      name.includes("grocer") ||
      name.includes("fresh") ||
      name.includes("supermarket") ||
      name.includes("food")
    ) {
      if (!groceryBannerRendered) {
        groceryBannerRendered = true;
        return <GroceryPromoBanner />;
      }
      return null;
    }

    if (
      name.includes("appliance") ||
      name.includes("kitchen") ||
      name.includes("home appliance")
    ) {
      if (!appliancesBannerRendered) {
        appliancesBannerRendered = true;
        return <HomeAppliancesPromoBanner />;
      }
      return null;
    }

    if (
      name.includes("electronic") ||
      name.includes("mobile") ||
      name.includes("computer") ||
      name.includes("gadget") ||
      name.includes("phone") ||
      name.includes("laptop")
    ) {
      if (!electronicsBannerRendered) {
        electronicsBannerRendered = true;
        return <ElectronicsPromoBanner />;
      }
      return null;
    }

    if (
      name.includes("fashion") ||
      name === "clothing" ||
      name === "apparel" ||
      name === "men" ||
      name === "women" ||
      name.includes("shoe") ||
      name.includes("footwear")
    ) {
      if (!fashionBannerRendered) {
        fashionBannerRendered = true;
        return <FashionPromoBanner />;
      }
      return null;
    }

    return null;
  };

  return (
    <>
      <div className="display-max container-fluid px-0">
        <HomeNavbar variant="home" />
        <HomeSecondaryNavbar
          variant="home"
          browsingHistoryOpen={browsingHistoryOpen}
          onBrowsingHistoryClick={() =>
            setBrowsingHistoryOpen((previous) => !previous)
          }
        />

        <HomeHeroShowcase />

        {/* Sponsored Brands + display ads — Amazon-style home banner */}
        <div className="container-fluid px-3 mt-3">
          <AdPlacement
            placement="home_feed"
            adTypes={["sponsored_brand", "display", "product"]}
            limit={3}
          />
        </div>
        {activeCategorySections.length > 0
          ? activeCategorySections.map((cat, index) => (
              <React.Fragment key={cat.id || index}>
                <MenFashionSection
                  categoryName={cat.name}
                  superCategory={cat.superCategory || cat.name}
                  promoBanner={getCategoryPromoBanner(cat.name)}
                />
              </React.Fragment>
            ))
          : superCategories.data.length > 0 &&
            superCategories.data.map((category, index) => (
              <React.Fragment key={category._id || index}>
                <MenFashionSection
                  categoryName={category.name}
                  superCategory={category.name}
                  promoBanner={getCategoryPromoBanner(category.name)}
                />
              </React.Fragment>
            ))}

        <CustomerTestimonials />
        <SellerTestimonials />
        <HomeSocialMedia />
      </div>
      <div className=" display-mini display-mob pb-5">
        <MobileHomePage
          activeCategorySections={activeCategorySections}
          superCategories={superCategories.data}
          getCategoryPromoBanner={getCategoryPromoBanner}
        />
      </div>
      <SideCart />
      <ProDetailModal product={selectedProduct} />
      <div
        className="offcanvas offcanvas-bottom bg-gray-100 vh-100"
        id="offcanvasSearch"
        aria-labelledby="offcanvasSearchLabel"
      >
        <div className="offcanvas-header p-2">
          <div className=" d-flex justify-content-between align-items-start">
            <div className=" text-end w-70"></div>
            <div>
              <button
                className=" btn text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <li className="avatar avatar-sm border shadow-lg border-radius-2xl opacity-6 bg-white">
                  <i className="bi bi-x-lg fs-6 text-black"></i>
                </li>
              </button>
            </div>
          </div>
        </div>
        <div className="offcanvas-body small">
          <div className=" card bg-white w-97 mx-auto p-3 border-radius-0 shadow-lg mb-3">
            <h4>Categories</h4>
            <div className=" mt-2 mb-2">
              <div className=" input-group input-group-outline input-group-lg">
                <input
                  type="text"
                  className=" form-control text-lg"
                  placeholder="Search for products, Brands"
                />
                <span className=" input-group-text">
                  <i className="fi fi-rr-search fs-6 me-2"></i>
                </span>
              </div>
              <b className=" text-xxs text-black fw-normal">
                Suggested Categories
              </b>
            </div>
            <WomenFashionSection />
          </div>
        </div>
      </div>
      <div
        className="offcanvas offcanvas-bottom bg-gray-100 vh-100"
        id="offcanvasAddress"
        aria-labelledby="offcanvasAddressLabel"
      >
        <div className="offcanvas-header p-2">
          <div className="d-flex justify-content-between align-items-start">
            <div className="text-end w-70"></div>
            <div>
              <button
                className="btn text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <li className="avatar avatar-sm border shadow-lg border-radius-2xl opacity-6 bg-white">
                  <i className="bi bi-x-lg fs-6 text-black"></i>
                </li>
              </button>
            </div>
          </div>
        </div>
        <div className="offcanvas-body small">
          <div className="card bg-white w-97 mx-auto p-3 border-radius-0 shadow-lg mb-3">
            <h4>Choose your location</h4>
            <p className="text-xs text-secondary">
              Shipping options and fees vary based on your location
            </p>
            <DeliveryLocationPicker />
          </div>
          {isAuthenticated && (
            <div className="card bg-white w-97 mx-auto p-3 border-radius-0 shadow-lg mb-3">
              <h4 className="text-start">Deliver to</h4>
              <p className="text-xs text-secondary text-start">
                Select or manage your delivery address
              </p>

              {addressLoading ? (
                <div className="text-center py-2">
                  <div
                    className="spinner-border spinner-border-sm text-dark"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : addresses && addresses.length > 0 ? (
                <ul className="list-unstyled mb-0">
                  {addresses.map((addr) => (
                    <li
                      key={addr._id}
                      className={`d-flex align-items-start gap-2 p-2 mb-1 rounded cursor-pointer ${
                        addr.defaultAddress
                          ? "bg-light border border-dark"
                          : "border border-transparent"
                      }`}
                      style={{ transition: "background 0.15s" }}
                      onClick={() => handleSelectDefault(addr)}
                    >
                      {/* Radio-style indicator */}
                      <div className="mt-1 flex-shrink-0">
                        <div
                          className={`rounded-circle border border-2 ${
                            addr.defaultAddress
                              ? "border-dark bg-dark"
                              : "border-secondary"
                          }`}
                          style={{ width: 14, height: 14 }}
                        />
                      </div>

                      <div className="flex-grow-1 text-start">
                        <div className="d-flex align-items-center gap-1">
                          <b className="text-black text-xs fw-bolder">
                            {addr.fullName}
                          </b>
                          <span
                            className="badge bg-secondary text-white text-xxs fw-normal"
                            style={{ fontSize: "0.6rem" }}
                          >
                            {addr.addressType}
                          </span>
                          {addr.defaultAddress && (
                            <span
                              className="badge bg-dark text-white text-xxs"
                              style={{ fontSize: "0.6rem" }}
                            >
                              Default
                            </span>
                          )}
                        </div>
                        <div className="text-xs text-secondary mt-1 text-wrap">
                          {addr.addressLine1}
                          {addr.addressLine2
                            ? `, ${addr.addressLine2}`
                            : ""}, {addr.city}, {addr.state} — {addr.pincode}
                        </div>
                        <div className="text-xs text-muted">{addr.country}</div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-center text-secondary text-xs py-2">
                  No addresses saved yet.
                </div>
              )}

              <hr className="my-2" />
              <button
                className="btn btn-sm rounded-pill btn-dark w-100 fw-bolder"
                onClick={() => {
                  const offcanvasEl =
                    document.getElementById("offcanvasAddress");
                  if (offcanvasEl) {
                    const bootstrap = (window as any).bootstrap;
                    if (bootstrap && bootstrap.Offcanvas) {
                      const bsOffcanvas =
                        bootstrap.Offcanvas.getInstance(offcanvasEl);
                      if (bsOffcanvas) bsOffcanvas.hide();
                    }
                  }
                  navigate("/ManageAddress");
                }}
              >
                <i className="ri-add-line me-1"></i>
                Add address
              </button>
            </div>
          )}
          <div className="card bg-white w-97 mx-auto p-3 border-radius-0 shadow-lg mb-3">
            <div
              className=" d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#collapseCountry"
              aria-expanded="true"
              aria-controls="collapseCountry"
            >
              <div className=" d-flex justify-content-start align-items-center gap-2 p-2">
                <div className=" lh-sm">
                  <b className=" text-black fw-normal text-md">
                    Choose Country & Language
                  </b>
                </div>
              </div>
              <div>
                <div>
                  <i className="bi bi-chevron-down me-2"></i>
                </div>
              </div>
            </div>
            <div
              id="collapseCountry"
              className="accordion-collapse collapse"
              aria-labelledby="country"
              data-bs-parent="#accordionCountry"
            >
              <div className="accordion-body ">
                <div className=" border border-radius-0 mt-3">
                  <CountryLanguage />
                </div>
              </div>
            </div>
          </div>
          <div className=" card bg-white w-97 mx-auto p-3 border-radius-0 shadow-lg mb-3">
            <div
              className=" d-flex justify-content-between align-items-center"
              data-bs-toggle="collapse"
              data-bs-target="#collapseCurrency"
              aria-expanded="true"
              aria-controls="collapseCurrency"
            >
              <div className=" d-flex justify-content-start align-items-center gap-2 p-2">
                <div className=" lh-sm">
                  <b className=" text-black fw-normal text-md">
                    Choose Currency
                  </b>
                </div>
              </div>
              <div>
                <div>
                  <i className="bi bi-chevron-down me-2"></i>
                </div>
              </div>
            </div>
            <div
              id="collapseCurrency"
              className="accordion-collapse collapse"
              aria-labelledby="address"
              data-bs-parent="#accordionCurrency"
            >
              <div className="accordion-body ">
                <div className=" border border-radius-0 mt-3">
                  <Currency />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const HomePage = () => {
  return (
    <HomePageProvider>
      <HomePageContent />
    </HomePageProvider>
  );
};

export default HomePage;
